import { Routes, Route,useLocation, useNavigate } from "react-router-dom";
import {  AnimatePresence } from "framer-motion";
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import NavBare from "./AssistantNavBare";
import AssistantFolderContent from "./AssistantFolderContent";
import AssistantHome from "./AssistantHome";
import AssistantProfile from "./AssistantProfle"
import AssistantLessonPage from "./AssistantLessonPage";
import NewExamPage from "../admin/NewExamPage";
import ExamReview from "../admin/ExamReview";
import BatchQrPdfGenerator from "../admin/BatchQrPdfGenerator";
import EditExam from "../admin/EditExam";
import { useEffect, useState, useContext } from "react";
import { GlobalContext } from "../GlobalContext";


export default function AssistantPages(){
    const navigate = useNavigate();
    const location = useLocation();
    const {admin, setAdmin} = useContext(GlobalContext);
    const [loaded, setLoaded] = useState(false);
    const [active, setActive] = useState("");
    const [mobileActive, setMobileActive] = useState("");


    const fetchData = async () => {
            let admin2 = admin;
            await axios.get(`${BASE_URL}/assistant/get-assistant-by-token`, { withCredentials: true })
                .then((response) => {
                    admin2 = response.data;
                    
                }).catch((error) => {
                    navigate("/"); // Redirect to login if admin data is not available
                })
                if(admin2 === null || admin2 === undefined){
                    navigate("/");
                    return;
                }

            await axios.get(`${BASE_URL}/assistant/courses`, { withCredentials: true })
            .then((response) => {
                admin2 = {...admin2, courses: response.data};
            }).catch((error) => {
                console.error("Error fetching course data:", error);
                navigate("/");
                // Handle error appropriately, e.g., show a notification or redirect
            })
            await axios.get(`${BASE_URL}/assistant/teacher-info`, { withCredentials: true }).
                then(async (response)=>{
                    const updatedAdmin = {...admin2, teacherName: response.data[1], teacherId: response.data[0]};
                    setAdmin(updatedAdmin);
                    setLoaded(true);
                }).catch((err)=>{
                    console.log(err);
                })
        
    }

    useEffect(()=>{
        fetchData();
    },[])


    return(
        <div>
            {loaded && (<div style={{background:"linear-gradient(195deg, #ffffff, #ffffff)",position:"absolute",
                 minHeight:"100%", width:"100%"}}>
                    <NavBare admin={admin} active={active} setActive={setActive} mobileActive={mobileActive} setMobileActive={setMobileActive} />
                    <AnimatePresence mode="wait">
                        <Routes location={location} key={location.pathname}>
                            <Route path="/" element={<AssistantHome active={active} setActive={setActive} mobilActive={mobileActive} setMobileActive={setMobileActive} />}/>
                            <Route path="assistant-profile" element={<AssistantProfile active={active} setActive={setActive} setMobileActive={setMobileActive}/>}/>
                            <Route path="folder/:parentId" element={<AssistantFolderContent active={active} setActive={setActive} mobilActive={mobileActive} setMobileActive={setMobileActive}/>} />
                            <Route path= "video-details/:id" element={<AssistantLessonPage setActive={setActive} setMobileActive={setMobileActive} />}/>
                            <Route path="new-exam/:unitId" element={<NewExamPage setActive={setActive} setMobileActive={setMobileActive} isAdmin={false}/>}/>
                            <Route path="preview-exam/:examId" element={<ExamReview setActive={setActive} setMobileActive={setMobileActive} isAdmin={false}/>}/>
                            <Route path="edit-exam/:examId" element={<EditExam setActive={setActive} setMobileActive={setMobileActive} isAdmin={false} />}/>                    
                            <Route path="lesson/qr-codes/:lessonId" element={<BatchQrPdfGenerator setActive={setActive} setMobileActive={setMobileActive} isAdmin={false} />}/>
                        </Routes>
                    </AnimatePresence>
            </div>)}
        </div>
    )

}